import { Grid, CircularProgress, Button } from '@mui/material';
import { sxStyle } from '../styles';

export const CancellationFeeCheck = ({
  index,
  onCheckCancellationFee,
  loading,
}) => {
  return (
    <Grid sx={{ display: 'flex', justifyContent: 'center' }}>
      <Button
        sx={sxStyle.cancellTextButton}
        disabled={loading}
        onClick={onCheckCancellationFee}
        id={`cancellationFeeCheckButton${index}`}
      >
        <span
          style={{
            visibility: loading ? 'hidden' : 'visible',
            textDecoration: 'underline',
            cursor: 'pointer',
            color: '#1976d2',
          }}
        >
          Consultar políticas de cancelación
        </span>

        {loading && (
          <CircularProgress
            size={20}
            sx={{
              position: 'absolute',
            }}
          />
        )}
      </Button>
    </Grid>
  );
};
